import { render, staticRenderFns } from "./TemplateListItem.vue?vue&type=template&id=0cc69911&scoped=true&"
import script from "./TemplateListItem.vue?vue&type=script&lang=js&"
export * from "./TemplateListItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListItem.vue?vue&type=style&index=0&id=0cc69911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc69911",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
